<template>
	<div style="width: 900px; height: 1300px; position: absolute; z-index: 10000; top: -10000px; left: -20000px; overflow: scroll;" v-if="isShowAlert">
			<div id="IDWorkProposalExportParent" v-if="isExporting"
				style="width: 900px; display: flex; flex-direction: column; padding-bottom: 25px; background: #ECF0F3; min-height: 1279px;">

				<div v-if="data" style="display: flex; height: 65px; position: relative;">
					<img v-if="type == 0" style="position: absolute; width: 100%; height: 65px;"
						src="../../../assets/icon_dean_home_alert_bg_1.png" alt="">
					<img v-if="type == 1" style="position: absolute; width: 100%; height: 65px;"
						src="../../../assets/icon_dean_home_alert_bg_3.png" alt="">
					<div
						style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; display: flex; justify-content: space-between; align-items: center;">
						<div style="display: flex; align-items: center; height: 100%;">
							<div style="width: 5px; height: 20px; background: #4A7CE8; border-radius: 0px 3px 3px 0px;">
							</div>
							<div
								style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #1F2635; line-height: 24px; margin-left: 20px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 660px;">
								{{ data.bedName || ' ' }}</div>
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 18px; color: #5E6779; line-height: 24px; margin-left: 12px;">{{ data.digitalTwinDateCn || '' }}</div>
						</div>
						<!-- <img style="width: 36px; height: 36px; margin-right: 15px;"
							src="../../../assets/icon_common_close_1.png" alt="" @click="isShowAlert = false" /> -->
					</div>
				</div>

				<div v-if="data"
					style="background: rgba(255,255,255,0.8); border-radius: 16px; border: 1px solid #FFFFFF; margin-top: 15px; margin-left: 24px; margin-right: 24px; position: relative;">
					<div
						style="position: absolute; left: 5px; right: 5px; top: 5px; bottom: 5px; border: 2px rgb(74, 124, 232, 0.15) solid; border-radius: 12px; overflow: hidden;">
						<div class="topCardBg" style="width: 100%; height: 100%;"></div>
					</div>
					<img style="width: 28px; height: 28px; position: absolute; left: -5px; top: -5px;"
						src="../../../assets/icon_dean_home_alert_icon_5.png" alt="">
					<img style="width: 28px; height: 28px; position: absolute; right: -5px; bottom: -5px;"
						src="../../../assets/icon_dean_home_alert_icon_4.png" alt="">
					<img style="width: 25px; height: 40px; position: absolute; right: 0px; top: -15px;"
						src="../../../assets/icon_dean_home_alert_icon_3.png" alt="">
					<div style="display: flex; flex-direction: column; justify-content: flex-start; padding-bottom: 20px;">
						<img style="width: 121px; height: 34px; margin-left: 20px; margin-top: 20px; align-self: flex-start;"
							src="../../../assets/icon_dean_home_alert_icon_1.png" alt="">
						<div v-for="(item, index) in data.recommendList || []"
							style="display: flex; margin-top: 10px; margin-bottom: 5px; margin-left: 20px; margin-right: 20px;">
							<div
								style="width: 8px; height: 8px; background: #4A7CE8; opacity: 0.2; border-radius: 4px; margin-top: 8px; margin-right: 5px;">
							</div>
							<div
								style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #8394B9; line-height: 22px; flex: 1;">
								{{ item }}</div>
						</div>
					</div>
				</div>

				<div v-if="data && chartDataList && chartDataList.length > 0"
						v-for="(item, index) in chartDataList || []">
					<ContentCardBaseA v-if="item.index != 'ahi' && item.index != 'bcRegular2Num' && item.index != 'breBpm' && item.index != 'breBpm2Num'"
						:echartId="'ContentCardBaseA' + index" :option="item.echartsOption" :data="item" :isFold="false" :type="type">
					</ContentCardBaseA>
					<ContentCardBaseB v-if="item.index == 'ahi'" :echartId="'ContentCardBaseB' + index"
						:option="item.echartsOption" :data="item"  :type="type"  :isFold="false"></ContentCardBaseB>
					<ContentCardBaseD v-if="item.index == 'bcRegular2Num'" :echartId="'ContentCardBaseD' + index"
						:option="item.echartsOption" :data="item"  :type="type" :isFold="false"></ContentCardBaseD>
					<ContentCardBaseE v-if="item.index == 'breBpm'" :echartId="'ContentCardBaseE' + index"
						:option="item.echartsOption" :optionAuxiliary="item.echartsOptionAuxiliary" :data="item"  :type="type" :isFold="false"></ContentCardBaseE>
					<ContentCardBaseF v-if="item.index == 'breBpm2Num'" :echartId="'ContentCardBaseF' + index"
						:option="item.echartsOption" :optionAuxiliary="item.echartsOptionAuxiliary" :data="item"  :type="type" :isFold="false"></ContentCardBaseF>
				</div>
			</div>
	</div>
</template>
  
<script>
import Healthy from '../../../component/healthy/healthy.vue';
import QlBtn from '../../../component/common/qlBtn.vue'
import ContentCardBaseA from '../component/contentCardBaseA.vue'
import ContentCardBaseB from '../component/contentCardBaseB.vue'
import ContentCardBaseD from '../component/contentCardBaseD.vue'
import ContentCardBaseE from '../component/contentCardBaseE.vue'
import ContentCardBaseF from '../component/contentCardBaseF.vue'


import EchartsDataDeal from '../component/options/echartsDataDeal.js'

import workProposalAlertData from './workProposalAlertData.json'

import WorkProposalFunction from './workProposalFunction.js'

import * as ExportPdfManager from '../../../utils/ExportPdfManager';

export default {
	components: { QlBtn, ContentCardBaseA, ContentCardBaseB, ContentCardBaseD, ContentCardBaseE, ContentCardBaseF, Healthy },
	props: {
		type: {
			type: Number,
			default: 0 // 0 - 红色，1 - 黄色
		},
	},
	watch: {

	},
	data() {
		return {
			isShowAlert: false,
			incomingData: null,
			data: null,
			chartDataList: null,
			isExporting: false,
			digitalTwinDate: null
		};
	},
	created() { },
	mounted() {
	},
	methods: {
		executeExport(data) {
			if (data && data.length > 0) {
				this.chartDataList = null;
				this.isShowAlert = true;
				this.incomingData = data;
				this.exportPdfFile();
			}
		},
		exportPdfFile() {
			if (this.incomingData && this.incomingData.length > 0) { // 可以导出
				let item = this.incomingData[0];
				this.getDetaiData(item);
			} else { // 不可以导出
				this.isShowAlert = false;
				this.$emit('exportFinish');
			}
		},
		getDetaiData(item) {
			let api = '';
			if (this.$props.type == 0) {
				api = 'api/dean/v5/timelyCareElderDetails';
			} else {
				api = 'api/dean/v5/longObserveElderDetails';
			}
			this.$get(
				api,
				{
					bedId: item.bedId
				},
				(res) => {
					// res = workProposalAlertData;
					if (res.code == 0) {
						if (res.data) {
							this.dealChartData(res.data.indexList)
							this.data = res.data;
							
							// let digitalTwinDate = res.data.digitalTwinDate;
							// if (digitalTwinDate && digitalTwinDate.indexOf('-') > 0) {
							// 	let arr = digitalTwinDate.split("-")
							// 	let needDate = '';
							// 	for (let i = 0; i < arr.length; i++) {
							// 		needDate += arr[i];
							// 		if (i == 0) {
							// 			needDate += '年';
							// 		} else if (i == 1) {
							// 			needDate += '月';
							// 		} else {
							// 			needDate += '日';
							// 		}
							// 	}
							// 	this.digitalTwinDate = needDate;
							// }
						}
						this.isExporting = true;
						setTimeout(() => {

							// 1.获取要导出的父元素
							var parentElement = document.getElementById('IDWorkProposalExportParent');
							parentElement.style.height = null;
							// 2.获取其所有子元素
							var parentElementChildrenElements = parentElement.children;
							// 3.当前页的高度
							let currentPageHeight = 0;
							// 4.遍历子组件
							for (let i = 0; i < parentElementChildrenElements.length; i++) {
								// 5.获取单个子组件
								let item = parentElementChildrenElements[i];
								// 6.获取单个子组件的高度
								let singleItemHeight = item.offsetHeight;
								// 7.判断当前页面+目前组件高度是否超过了一页的长度
								if (currentPageHeight + singleItemHeight <=1279) {
									currentPageHeight = currentPageHeight + singleItemHeight;
								} else {
                                    let div = document.createElement("div");
									let needHeight = 1279 - currentPageHeight;
									let px = needHeight + 'px'
                                    div.style.height = px;
                                    // div.style.background = 'red';
                                    item.parentNode.insertBefore(div, item);
									currentPageHeight = 0;
								}
							}
							setTimeout(() => {
								ExportPdfManager.exportPdfFile(document, 'IDWorkProposalExportParent', (item.bedName + '的报告'))
								.then(() => {
									this.isExporting = false;
									let tempArr = JSON.parse(JSON.stringify(this.incomingData))
									tempArr.shift();
									this.incomingData = tempArr;
									this.exportPdfFile()
								});
							}, 1000);
						}, 1000);
					} else {
						let tempArr = JSON.parse(JSON.stringify(this.incomingData))
						tempArr.shift();
						this.incomingData = tempArr;
						this.exportPdfFile()
					}
				},
				(err) => {
					let tempArr = JSON.parse(JSON.stringify(this.incomingData))
					tempArr.shift();
					this.incomingData = tempArr;
					this.exportPdfFile()
				}
			);
		},

		dealChartData(arr) {
			// 1.不存在则直接置空
			if (!arr || arr.length == 0) {
				this.chartDataList = null;
				return
			}

			// 2.组装新的图表数组 - 添加新字段 echartsOption、subTitle
			let needArr = [];
			for (let i = 0; i < arr.length; i++) {
				let item = arr[i];
				let needItem = JSON.parse(JSON.stringify(arr[i]));



				// option
				needItem.echartsOption = WorkProposalFunction.getNeedOption(item, this.$props.type);

				// icon
				needItem.icon = WorkProposalFunction.getNeedIcon(item);

				// questionMarkType
				needItem.questionMarkType = WorkProposalFunction.getNeedQuestionMarkType(item);

				// subTitle
				needItem.subTitle = WorkProposalFunction.getNeedSubTitle(item);

				// subQuestionMarkType
				needItem.subQuestionMarkType = WorkProposalFunction.getNeedSubQuestionMarkType(item);

				// leftTip
				needItem.leftTip = WorkProposalFunction.getNeedLeftTip(item);

				// rightTip
				needItem.rightTip = WorkProposalFunction.getNeedRightTip(item);



				needArr.push(needItem)
			}
			this.chartDataList = needArr;
		},
	},
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';

.topCardBg {
	background: url('../../../assets/icon_dean_home_alert_icon_2.png') no-repeat no-repeat;
	background-size: 840px 100%;
}
</style>
  